import type { LogoDarkProps } from "./LogoDark.style";

export const LogoDark: React.FC<LogoDarkProps> = ({ className = "" }) => {
    return (
        <img
            src="/images/logo-dark.svg"
            alt="Defy Medical"
            className={`h-auto w-auto ${className}`}
        />
    );
};
